import React, {Component} from 'react';
import {Input, Popover, Button, Tabs, Empty, Form, Upload, Spin, Modal, Icon, Divider, Tooltip} from 'antd';
import {message} from "../../sysManagement/utils/sysManagementUtils";
import {EditableTagGroup} from "../../../components/editableTagGroup";
import {WeiboPicturesWall} from "./weiboPicturesWall";
import ReactDOM from 'react-dom';
import {uuid} from "../../../utils";
import * as utils from "../../../utils";
import {
    getWeiboByWeiboId,
    saveStatusName,
    deleteWeibo,
    getRevokeWeibo,
    getUserInfo,
    getButtonByMediaCode,
    searchUser,
    hotTopic,
    location, updateProcessData
} from "./weiboActions";
import {Scrollbars} from "react-custom-scrollbars";
import ChooseUserModal from "../../../containers/chooseUserModal";
import {connect} from "react-redux";
import {activiti, Activiti} from "../../../components/activity/public";
import ActivitiModal from "./../../../view/editor/components/activitiAndBtn/ActivitiModal";
import BaseComponent from "../../../base/BaseComponent";
import LinkCheck from "../../editor/components/pluginsSpace/linkCheck/linkCheck"
import {HEADER_HEIGHT} from "../../../constants";
import SyncModal from "../../components/syncModal/syncModal";
import SecurityCheck, {
    addContentSecurityByText,
    formatItem,
    removeContentSecurity,
    removeColorByInheritCheck
} from "../component/securityCheck/securityCheck";
import RmtTextArea from "../component/rmtTextArea/rmtTextArea";
import $ from "jquery";

const {TextArea} = Input;
const {TabPane} = Tabs;
const {confirm} = Modal;
let taskPublishDate;

class EditWeiBo extends BaseComponent {
    currentUser;
    weiboId = this.props.weiboId || "";
    fatherObj = this.props.fatherObj;
    statusNameTemp = "";
    statusName = "";
    textareaModalTitle = '备注';
    callbackType = '';
    publishUrl = '';
    buttonRole = {};
    activitiObj = {};
    needRefreshList = false;

    constructor(props) {
        super(props);
        this.state = {
            mediaId: props.currentMedia,
            weiboId: props.weiboId,
            mediaName: props.mediaName,
            weiboUserName: "",
            type: "face",
            fontSize: 0,
            content: props.content,
            showNowStr: <span>输入</span>,
            fileList: [],
            tags: [],
            btns: [],
            loading: false,
            textareaModalVisible: false,    // 撤稿的备注框
            uploadVisible: false,
            userNameVisible: false,
            htVisible: false,
            videoVisible: false,
            placeVisible: false,
            remarksContent: "",
            timeSelect: null,
            placeData: [],//定位类搜索
            placeValue: undefined,
            openPlace: false,
            topicData: [],//话题类搜索
            topicMenu: [],
            topicValue: undefined,
            topicId: '',
            openTopic: false,
            userNameData: [],//@名字搜索
            userNameValue: undefined,
            openUserName: false,
            isTouTiaoArticle: false,
            touTiaoArticleInfor: {},
            currentData: {},
            userInfo: {},
            activityOption: {},// 审核流所需参数
            actBtn: [],
            currentItem: {},
            noInfoCheckRecord: this.props.noInfoCheckRecord || []
        };
        this.currentUser = this.props.currentUser;

        // this.initButtonRole(()=>{     //通过媒体角色权限判断按钮
        this.initWeiboData();
        // });
    };

    initButtonRole(callback) {
        getButtonByMediaCode([{"mediaId": this.state.mediaId}], (dataJson) => {
            if (dataJson) {
                this.buttonRole = dataJson;
            }
            callback();
        });
    };

    getActivityOption(item) {
        let id = this.props.weiboId ? this.props.weiboId : '';
        let that = this;
        let canDo = true;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        this.state.activityOption = {
            id: id,//流程id
            activitiConf: {
                type: "activitiTreeRoot-weibo",
            },//流程conf,//流程conf
            pojoName: 'weibo',//数据表nam
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            btnType: "weibo",  //写一个流程按钮文件/btnList/weibo.js
            againFlag: item && (item.statusName === '草稿' || item.statusName === '已撤稿'),//重置流程的判断条件
            showAfterFuns: {
                //撤回按钮显示前置js
                callBackBtnShow: function (item, call) {
                    //不允许编辑
                    canDo = false;
                    call({"code": 1});
                },
                publishCheck: function (item, call) {
                    if (that.buttonRole.publish == true) {
                        call({code: 1, log: "拥有发布权限"});
                    } else {
                        call({code: 0, log: "未拥有发布权限"})
                    }
                },
                //弃用按钮显示前置js
                abandon: function (item, call) {
                    if (id) {
                        call({code: 1, log: "拥有弃用权限"});
                    } else {
                        call({code: 0, log: "未拥有弃用权限"})
                    }
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                callActRevert: (activiti, buttonConf, call) => {
                    activiti.terminate.call(activiti, (res) => {
                        if (res) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res.status) {
                                    activiti.successMsg("流程已撤回，稿件变为草稿状态", function () {
                                        activiti.submitOK.call(activiti);
                                    });
                                }
                            })
                        }
                    });
                },
                callPublish: function (activiti, buttonConf, call) {
                    call && call({code: 1})
                    // if (!that.state.stuffList || that.state.stuffList.length === 0) {
                    //     message.warn("请至少添加一个图文");
                    //     that.setState({
                    //         loading: false
                    //     })
                    //     return;
                    // }
                    // that.setState({
                    //     publishModalVisible: true
                    // });
                    // that.callback = call;
                    // that.isActPublish = true;
                },
                checkPublishTitle: function (activiti, buttonConf, call) {
                    let params = that.getParams();
                    that.request({
                        url: "/cm-sites-pms/weibo/checkPublishTitle",
                        method: "post",
                        contentType: "json",
                        body: params,
                        callBack: (res) => {
                            if(res) {
                                call && call({code: 1})
                            }else {
                                call && call({code: -1, log: "相同内容请隔十分钟再进行发布！"})
                            }
                        }
                    })
                },
            },//流程按钮点击事件前置js
            saveFunction: that.onlySave,//保存方法
            saveStatusNameFunction: that.updateStatusName,//改流程状态方法
            publish: that.publish,//改流程状态方法
            showRemarks: (remarks) => {
                if (remarks && remarks.length) {
                    that.state.btns.push({
                        name: "查看备注",
                        type: "remarks"
                    });
                    that.setState({remarks})
                }
            },//备注回显
            onSubmitOK: function (activiti) {
                that.refreshList(activiti)
            },//流程事件运行完毕的回调
            successCall: (activiti) => {
                activiti.submitRemoteSuccessMsg = function (statusNameTemp, call) {
                    activiti.successMsg(statusNameTemp + '成功', function () {
                        call && call();
                    })
                }
                that.activitiObj = activiti;
                that.setState({})
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            mustNotShowPublishBtn: true,
            btnLoadOver: (btns) => {
                this.setState({
                    actBtn: btns
                }, () => {
                    //其他按钮
                    this.getOtherBtn(this.state.currentData, that);
                });
            },
            chooseFilterObject: function(users, call) {
                if(!users || users.length<1) {
                    call&&call(users);
                    return false
                }
                let mediaInfo = {mediaId: that.state.mediaId};
                if(!mediaInfo) {
                    message.warn("过滤媒体权限失败，请先选择主栏目");
                    return false
                }
                let receivers = users.map(item=>({
                    deptId: item.deptData[0]._id,
                    userId: item._id,

                }));
                that.request({
                    url: "/cm-sites-pms/contribute/filterUser",
                    method: "post",
                    contentType: "json",
                    body: {
                        mediaInfo,
                        receivers
                    },
                    callBack: (list) => {
                        let newUsers = [];
                        if(list&&list.length) {
                            newUsers=list
                            call && call(newUsers)
                        } else {
                            message.warning("未查到拥有媒体权限的待办用户");
                            window.loading.hide();
                        }
                    },
                    errorCallBack: () => {
                        this.error("过滤媒体权限失败,请稍后重试");
                    },
                });
            },
            checkForm: that.checkForm
        };
        this.setState({})
    };

    checkForm = (activiti, call) => {
        let title = this.getTitleText();
        if (title.trim() === "") {
            message.warning("请输入微博正文！");
            activiti && activiti.load.end();
            this.closeLoad();
            return false;
        }

        if (title.length > 500) {
            message.warning("微博正文不能大于500字！");
            activiti && activiti.load.end();
            this.closeLoad();
            return false;
        }
        call && call()
    };

    updateStatusName = (statusName, activiti, call) => {
        this.needRefreshList = true;
        saveStatusName({
            id: this.weiboId,
            statusName: statusName
        }, (data) => {
            if (data) {
                call({status: true, msg: data.msg});
            } else {
                call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    publish = (statusName, activiti, call) => {
        let that = this;
        let params = that.getParams();
        if (statusName.indexOf("发布") > -1) {
            let url = '/cm-sites-pms/weibo/publish';
            params.id = that.weiboId;
            this.request({
                url: url,
                body: params,
                method: 'post',
                contentType: 'json',
                callBack: (res) => {
                    if (res && res.id) {
                        that.weiboId = res.id;
                        res.statusName = activiti.options.statusNameTemp;
                        res.mediaId = this.state.mediaId;
                        if (res) {
                            call({status: true, msg: res.msg});
                        } else {
                            call({status: false, msg: "流程推进后状态发布失败。"});
                        }
                    }
                },
                serverVerify: {
                    serverErrorCallBack: (e, allData) => {
                        that.state.weiboId = that.weiboId;
                        this.setState({})
                    }
                },
                errorCallBack: (e) => {

                }
            })
        }
    };

    getOtherBtn(data, that) {
        // 其他按钮
        let buttonList = [];
        if (((data && !data.id) || (data && (data.statusName === '已撤稿' || data.statusName === '草稿') && (window.top.currentUser.id === data.submitter)))) {
            buttonList.push({
                name: "保存",
                type: "save"
            })
        }
        if (data && data.statusName === '已发布') {
            buttonList.push({
                name: "访问",
                type: "view"
            }, {
                name: "撤稿",
                type: "revert"
            });
        }
        if (data && data.statusName && (data.statusName.indexOf("失败") > -1 || data.statusName.indexOf("撤稿") > -1 || data.statusName === "草稿" || data.statusName.indexOf("弃用") > -1) && (window.top.currentUser.id === data.submitter)) {
            buttonList.push({
                name: "删除",
                type: "delete"
            });
        }

        this.setState({btns: buttonList});
    }

    callback = () => {
    };

    refreshList(activiti) {
        if (this.props.changeLoading) {
            this.props.changeLoading(false);
        }
        if (this.props.fatherObj) {
            this.props.fatherObj.refreshList();
        } else {
            this.props.refreshList();
        }
        activiti && activiti.load.end();
    }

    onClick = (type) => {
        this.closeLoad();
        if (type === "save") {
            this.checkForm(null,()=>{
                this.onlySave(null,null,"onlySave");
            })
        } else if (type === "revert") {
            this.getRevokeWeibo();
        } else if (type === "view") {
            window.open(this.publishUrl);
        } else if (type === "delete") {
            this.deleteWeiBo()
        } else if (type === "remarks") {
            this.showRemarksCall()
        }
    };

    // 查看备注
    showRemarksCall(){
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
                that.syncModal.destroy();
            },
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    }

    remarks;

    textareaHandleOk = () => {
        let remarks = this.remarks.state.value;
        if (remarks && remarks !== "") {
            let callbackValue = {};
            callbackValue.remarks = remarks;
            callbackValue.type = this.callbackType;
            this.callback(callbackValue);
            this.setState({
                textareaModalVisible: false
            })
        } else {
            message.error("请填写备注");
            this.closeLoad();
        }
    };

    textareaHandleCancel = () => {
        this.remarks.setState({
            value: ""
        })
        //关闭窗口
        this.setState({
            textareaModalVisible: false
        });
        this.closeLoad();
    };

    initWeiboData() {
        //头条文章编辑逻辑
        if (this.props.touTiaoParms?.touTiaoArticle && this.props.touTiaoParms.touTiaoArticle.cover) {
            let touTiaoParms = this.props.touTiaoParms;
            this.state.isTouTiaoArticle = true;
            this.state.touTiaoArticleInfor = touTiaoParms.touTiaoArticle;
            this.state.tags = touTiaoParms.labelNames;
            this.state.content = touTiaoParms.content;
            this.state.fontSize = touTiaoParms.content.length;
            if(this.props.touTiaoParms?.touTiaoArticle?.title) {
                this.state.content = this.props.touTiaoParms?.touTiaoArticle.title;
                this.state.fontSize = this.props.touTiaoParms?.touTiaoArticle.title.length;
            }
            this.state.currentData = {...touTiaoParms};
            if (this.props.weiboId) {
                this.weiboId = touTiaoParms.initWeiBoId;
                this.statusName = touTiaoParms.statusName;
                this.state.weiboUserName = touTiaoParms.submitter;
                this.publishUrl = touTiaoParms.publishUrl;
                // actInit(touTiaoParms, this);
                this.getActivityOption(touTiaoParms);
            } else {
                this.weiboId = "";
                // actInit(null, this);
                this.getActivityOption();
            }
            this.setState({});
        } else {
            if (this.weiboId) {
                if (!this.props.userInfo) {
                    getUserInfo(this.state.mediaId, (data) => {
                        if (data) {
                            if (data.profile_url && data.profile_url !== "") {
                                this.state.userInfo = data;
                            } else {
                                this.state.userInfo = {};
                            }
                        } else {
                            this.state.userInfo = {};
                        }
                    });
                }
                let params = {
                    id: this.weiboId
                }
                getWeiboByWeiboId(params, (data) => {
                    if (data) {
                        let newFileList = [];
                        this.statusName = data.statusName;
                        this.publishUrl = (data.touTiaoArticle && data.touTiaoArticle.url) ? data.touTiaoArticle.url : data.publishUrl;
                        for (let i = 0; i < data.picUrls.length; i++) {
                            let picFile = {
                                uid: i,
                                name: '',
                                status: 'done',
                                url: data.picUrls[i]
                            };
                            newFileList.push(picFile);
                        }
                        let newState = this.formatContent(data.title,'request');
                        if (data.cover) {
                            this.state.isTouTiaoArticle = true;
                            let title = data.title && data.title;
                            let touTiaoArticle = {
                                title: title,
                                content: data.content,
                                cover: data.cover,
                                summary: data.summary
                            }
                            this.state.touTiaoArticleInfor = touTiaoArticle;
                        }
                        this.state.currentData = data;
                        this.setState({
                            ...newState,
                            fileList: newFileList,
                            tags: data.tags,
                            weiboUserName: data.submitterName,
                            currentItem: data
                        });
                        this.uploadfileNum = newFileList.length;
                        // actInit(data, this);
                        this.getActivityOption(data);
                    }
                });
            } else {
                // actInit(null, this);
                this.getActivityOption();
            }
        }
    }

    isupload = true;
    uploadfileNum = 0; //上传的图片个数计数开始值
    uploadfileMaxNum = 18; //允许上传的图片最大数

    uploadProps = {
        accept: "."+["jpg","jpeg","gif","png"].join(",."),
        name: 'file',
        action: '/storage/uploadFile',
        headers: {
            authorization: 'authorization-text',
        },
        data: {dataSource: 7},
        multiple: true,
        showUploadList: false,
        onChange: ({fileList}) => {
            if (this.isupload) {
                this.setState({fileList});
            } else {
                this.uploadfileNum = this.state.fileList.length;
                this.uploadPicturesWall.setState({fileList: this.state.fileList});
            }
        },
        beforeUpload: file => {
            this.uploadPicturesWall.setState({
                fileList: this.state.fileList
            })
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
            if (!isJpgOrPng) {
                message.error("请上传后缀名为jpg、png或gif的图片");
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                message.error("请上传小于5M的图片");
            }

            this.uploadfileNum++;
            let isOverstep = false;
            if (this.uploadfileNum > this.uploadfileMaxNum) {
                message.error("最多上传" + this.uploadfileMaxNum + "张照片");
                isOverstep = true;
            }

            if (!(isJpgOrPng && isLt5M) || isOverstep) {
                this.isupload = false;
                this.uploadfileNum = 0;
                return false;
            }
        },
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            content: nextProps.content,
            noInfoCheckRecord: nextProps.noInfoCheckRecord
        })
    }

    handleRemove = async file => {
        const index = this.state.fileList.indexOf(file);
        const newFileList = this.state.fileList.slice();
        newFileList.splice(index, 1);
        this.uploadfileNum--;
        this.setState({
            fileList: newFileList
        });
        if (this.uploadPicturesWall) {
            this.uploadPicturesWall.setState({
                fileList: newFileList
            })
        }
    };

    getEmotionType() {
        let types = [];
        let emotionTypes = this.props.emotionsDataSource;
        for (let i = 0; i < emotionTypes.length; i++) {
            let emotionType = emotionTypes[i];
            types.push(<TabPane tab={emotionType.category} key={i}>
                <table>
                    <tbody>
                    {
                        this.setEmotions(emotionType.emotion).map(tr => {
                            return <tr key={uuid()}>
                                {tr.map(td => {
                                    return <td key={uuid()} width={36} height={34} align={"center"}
                                               style={{border: "1px solid #e8e8e8"}}>{td}</td>;
                                })}
                            </tr>
                        })
                    }
                    </tbody>
                </table>
            </TabPane>);
        }
        return types;
    }

    setEmotions(emotions) {
        let rowNum = 15; //一行显示15个
        let tdComponents = [];
        let saveIndex = 1;
        let tdComponent = [];
        for (let i = 0; emotions && i < emotions.length; i++) {
            let emotion = emotions[i];
            tdComponent.push(<img width={26} style={{padding: "2px", cursor: "pointer"}}
                                  onClick={this.insertEmotion.bind(this, emotion)} title={emotion.value}
                                  src={emotion.icon}/>);
            if (saveIndex == (rowNum)) {
                tdComponents.push(tdComponent);
                tdComponent = [];
                saveIndex = 0;
            } else {
                if (i == (emotions.length - 1)) {
                    tdComponents.push(tdComponent);
                }
            }
            saveIndex++;
        }
        return tdComponents;
    }

    insertEmotion(emotion) {
        let newValue = this.contentWapper.insetIntoTextArea(emotion.value);
        this.setContent(newValue);
    }

    renderEmotionsDataSource() {
        if (this.props.emotionsDataSource.length === 0) {
            return <Empty/>
        }
        return (<div style={{width: "440px"}}>
            <Tabs type="line" size="small" tabBarGutter={0}>
                {
                    this.getEmotionType().map(etype => {
                        return etype;
                    })
                }
            </Tabs>
        </div>);
    }

    closeModal() {
        if(this.needRefreshList) {
            this.refreshList();
        }
        if (this.fatherObj) {
            this.fatherObj.setState({
                visible: false,
            });
        }
    }

    uploadPicturesWall;
    weiboPicturesWall;

    renderUploadImage() {
        return (
            <div>
                <Upload {...this.uploadProps} ref={(that) => this.uploadPicturesWall = that}>
                    <Button icon={"upload"} onClick={this.closeUpload.bind(this)}>本地上传 </Button>
                </Upload>
                {/*<button>从资源库选择</button>*/}
            </div>
        );
    }

    closeUpload() {
        this.isupload = true;
        this.setState({
            uploadVisible: false,
        });
    }

    handleUploadVisibleChange = uploadVisible => {
        this.setState({uploadVisible});
    }

    setContent(newValue) {
        this.setState(this.formatContent(newValue));
    }

    formatContent(newValue,type) {
        let num = this.getTitleLength();
        if(type==='request') {
            // 接口参数进入
            num = newValue?.length || 0
        }
        let data = {
            content: newValue,
            fontSize: num,
            showNowStr: <span>输入</span>
        };
        if(this.state.touTiaoArticleInfor?.title) {
            let text = this.getTitleText();
            this.state.touTiaoArticleInfor.title = text
        }
        return data
    }

    userInput;

    setUserName() {
        let username = this.userInput.state.value;
        if (username && username.trim() !== "") {
            let newValue = this.contentWapper.insetIntoTextArea("@" + username);
            this.setContent(newValue);
            this.userInput.state.value = "";
            this.setState({
                userNameVisible: false,
            });
        } else {
            message.error("请输入用户名！");
        }
    }

    handleUserNameVisibleChange = userNameVisible => {
        this.state.openUserName = userNameVisible;
        this.setState({userNameVisible});
    };

    htInput;

    setHt() {
        let ht = this.htInput.state.value;
        if (ht && ht.trim() !== "") {
            let newValue = this.contentWapper.insetIntoTextArea("#" + ht + "#");
            this.setContent(newValue);
            this.htInput.state.value = "";
            this.setState({
                htVisible: false,
            });
        } else {
            message.error("请输入话题！");
        }
    }

    handleHtVisibleChange = htVisible => {
        this.state.openTopic = htVisible;
        this.setState({htVisible});
    };

    videoInput;

    setVideo() {
        let videoUrl = this.videoInput.state.value;
        if (videoUrl && videoUrl.trim() !== "") {
            let newValue = this.contentWapper.insetIntoTextArea(videoUrl);
            this.setContent(newValue);
            this.videoInput.state.value = "";
            this.setState({
                videoVisible: false,
            });
        } else {
            message.error("请输入视频地址！");
        }
    }

    handleVideoVisibleChange = videoVisible => {
        this.setState({videoVisible});
    };

    placeInput;

    setPlace() {
        let placeStr = this.placeInput.state.value;
        if (placeStr && placeStr.trim() !== "") {
            let newValue = this.contentWapper.insetIntoTextArea("#" + placeStr + "[地点]#");
            this.setContent(newValue);
            this.placeInput.state.value = "";
            this.setState({
                placeVisible: false,
            });
        } else {
            message.error("请输入定位！");
        }
    }

    handlePlaceVisibleChange = placeVisible => {
        this.state.openPlace = placeVisible;
        this.setState({placeVisible});
    };

    editableTagGroup;

    getParams() {
        let weiboId = this.state.weiboId;
        let content = this.getTitleText();
        let picUrlsStr = [];
        let picList = this.state.fileList;
        for (let i = 0; i < picList.length; i++) {
            let pic = picList[i];
            if (this.weiboId) {
                if (pic.url) {
                    picUrlsStr.push(pic.url);
                } else if (pic.response && pic.response.data) {
                    picUrlsStr.push(pic.response.data.path);
                }
            } else if (pic.response && pic.response.data) {
                picUrlsStr.push(pic.response.data.path);
            }
        }

        let tagsStr = [];
        if (this.editableTagGroup) {
            let tagsList = this.editableTagGroup.state.tags;
            for (let i = 0; i < tagsList.length; i++) {
                tagsStr.push(tagsList[i]);
            }
        }

        let touTiaoArticle = this.state.touTiaoArticleInfor.cover ? this.state.touTiaoArticleInfor.cover : null;
        let touTiaoArticleSummary = this.state.touTiaoArticleInfor.summary ? this.state.touTiaoArticleInfor.summary : ""
        let touTiaoArticleContent = this.state.touTiaoArticleInfor.content ? this.state.touTiaoArticleInfor.content : ""

        return {
            "content": touTiaoArticleContent,
            "cover": touTiaoArticle,
            "id": weiboId,
            "mediaId": this.state.mediaId,
            "picUrls": picUrlsStr,
            "summary": touTiaoArticleSummary,
            "tags": tagsStr,
            "title": content,
        }
    }

    onlySave = (activiti, callback,isOnlySave) => {
        let that = this;
        let url = '/cm-sites-pms/weibo/save';
        let params = that.getParams();
        this.needRefreshList = true;
        this.request({
            url: url,
            body: params,
            method: 'post',
            contentType: 'json',
            callBack: (data) => {
                if (data && data.id) {
                    that.weiboId = data.id;
                    that.state.weiboId = data.id;
                    this.onCheckSave(()=>{
                        if (callback) {
                            data.statusName = activiti.options.statusNameTemp;
                            data.mediaId = this.state.mediaId;
                            callback(data);
                        } else {
                            message.success("保存成功！");
                            this.props.onSaveCall(data.id);
                            this.initWeiboData();
                            // that.closeModal();
                            // that.refreshList();
                        }
                        this.updateProcessAndData(data);
                    },activiti,isOnlySave);
                }
            }
        })
    }

    // 更新流程稿件
    updateProcessAndData(body) {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body: {
                title: body?.title,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res) => {

            }
        })
    };

    deleteWeiBo() {
        confirm({
            title: '是否要删除本条微博 ？',
            onOk: () => {
                deleteWeibo({id: this.weiboId}, (data) => {
                    if (data) {
                        this.closeModal();
                        this.refreshList();
                        message.success("删除成功");
                        this.props.removeWeibo(this.weiboId);
                    } else {
                        message.error("删除失败");
                    }
                });
                this.closeLoad();
            },
            onCancel: () => {
            },
        });
    }

    getRevokeWeibo() {
        let that = this;
        confirm({
            title: '是否要撤稿本条微博 ？',
            onOk: () => {
                getRevokeWeibo({id: that.weiboId}, (data) => {
                    if (data) {
                        let params = {
                            id: this.weiboId,
                            statusName: "已撤稿"
                        };
                        saveStatusName(params, (data) => {
                            message.success("撤稿成功");
                            that.refreshList();
                            that.closeModal();
                            that.updateProcessStatusData()
                        });
                    } else {
                        message.error("撤稿失败");
                    }
                });
            },
            onCancel() {
            },
        });
    }

    updateProcessStatusData() {
        let params = {
            bizKey: this.weiboId,
            operatorUser: window.top.currentUser.id,
            taskName: "已撤稿",
            data: this.state.currentItem
        }
        updateProcessData(params, (data) => {
        });
    }

    contentWapper = new TextAreaWapper();

    syncTagsToSuperclass = (tags) => {
        this.onChangeByCheck();
        this.setState({tags});
    };

    openLoad = () => {
        if (this.props.changeLoading) {
            this.props.changeLoading(true);
        }
        this.setState({
            loading: true,
        })
    }

    closeLoad = () => {
        if (this.props.changeLoading) {
            this.props.changeLoading(false);
        }
        this.setState({
            loading: false,
        })
    };
    onChangeByCheck = () => {
        if(typeof this.securityCheck?.setCheckStatus === "function") {
            this.securityCheck.setCheckStatus("change",()=>{
                this.setState({})
            })
        }
    };
    renderLeft = () => {
        return (
            <div style={{width:860}}>
                <Scrollbars autoHeight autoHeightMax={516}>
                    <div style={{padding: "24px 40px 24px 40px"}}>
                        <div style={{
                            padding: "0px 0px 12px 0px", fontSize: 14,
                            fontFamily: "Microsoft YaHei", color: "rgba(0, 0, 0, 0.85)"
                        }}>微博正文
                        </div>
                        {this.state.isTouTiaoArticle === true ? "" : this.renderCheckResult()}
                        <div>
                            <WrappedWeiboContentForm setContent={this.setContent.bind(this)}
                                                     onChangeByCheck={this.onChangeByCheck}
                                                     contentWapper={this.contentWapper}
                                                     checkData={this.checkData}
                                                     fieldData={{content: {value: this.state.content}}}/>
                        </div>
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <div style={{zIndex: "9999999"}} id={"weiboPopover"}>
                                <Popover placement="bottomLeft" content={this.renderEmotionsDataSource()} trigger="click"
                                         style={{width: "20px;"}} arrowPointAtCenter>
                                    <img style={{cursor: "pointer", padding: "10px 10px 0px 0px"}}
                                         src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                                </Popover>
                                {this.state.isTouTiaoArticle ? null :
                                    <Popover placement="bottomLeft" content={this.renderUploadImage()} trigger="click"
                                             style={{width: "20px;"}} visible={this.state.uploadVisible}
                                             onVisibleChange={this.handleUploadVisibleChange} arrowPointAtCenter>
                                        <img style={{cursor: "pointer", padding: "10px 10px 0px 10px"}}
                                             src={"/cm-sites/images/mediaFusion/tupian.png"}/>
                                    </Popover>}
                                <Popover placement="bottomLeft" content={
                                    <div style={{width: "325px", display: "flex"}}>
                                        <Input style={{width: "250px"}} ref={(that) => this.userInput = that}
                                               placeholder="请输入用户名"/>
                                        <div style={{marginLeft: 10}}>
                                            <Button type="primary" onClick={this.setUserName.bind(this)}>确定</Button>
                                        </div>
                                    </div>
                                } trigger="click" style={{width: "20px;"}} visible={this.state.userNameVisible}
                                         onVisibleChange={this.handleUserNameVisibleChange} arrowPointAtCenter>
                                    <img style={{cursor: "pointer", padding: "10px 10px 0px 10px"}}
                                         src={"/cm-sites/images/mediaFusion/aite.png"}/>
                                </Popover>
                                <Popover placement="bottomLeft" content={
                                    <div style={{width: "325px", display: "flex"}}>
                                        <Input style={{width: "250px"}} ref={(that) => this.htInput = that}
                                               placeholder="请输入话题"/>
                                        <div style={{marginLeft: 10}}>
                                            <Button onClick={this.setHt.bind(this)}
                                                    type="primary">确定</Button>
                                        </div>
                                    </div>
                                } trigger="click" style={{width: "20px;"}} visible={this.state.htVisible}
                                         onVisibleChange={this.handleHtVisibleChange} arrowPointAtCenter>
                                    <img style={{cursor: "pointer", padding: "10px 10px 0px 10px"}}
                                         src={"/cm-sites/images/mediaFusion/huati.png"}/>
                                </Popover>
                                {
                                    this.state.isTouTiaoArticle ? null : <Popover placement="bottomLeft" content={
                                        <div style={{width: "325px"}}>
                                            <p>请输入
                                                <a href={"http://video.sina.com.cn/"} target={"_blank"}>新浪播客</a>，
                                                <a href={"https://www.youku.com/"} target={"_blank"}>优酷网</a>，
                                                <a href={"https://www.tudou.com/"} target={"_blank"}>土豆网</a>，
                                                <a href={"https://www.ku6.com/index"} target={"_blank"}>酷6网</a>，
                                                <a href={"https://tv.sohu.com/"} target={"_blank"}>搜狐视频</a>，
                                                <a href={"https://www.56.com/"} target={"_blank"}>56网</a>，
                                                <a href={"https://www.iqiyi.com/"} target={"_blank"}>爱奇艺</a>，
                                                <a href={"https://www.ifeng.com/"} target={"_blank"}>凤凰网</a>，
                                                <a href={"http://www.yinyuetai.com/"} target={"_blank"}>音悦台</a>，
                                                <a href={"http://www.le.com/"} target={"_blank"}>乐视网</a>，
                                                <a href={"http://www.miaopai.com/"} target={"_blank"}>秒拍</a>
                                                等视频网站的视频播放页链接。</p>
                                            <div style={{display: "flex"}}>
                                                <Input style={{width: "250px"}} ref={(that) => this.videoInput = that}
                                                       placeholder="请输入视频地址"/>
                                                <div style={{marginLeft: 10}}>
                                                    <Button onClick={this.setVideo.bind(this)}
                                                            type="primary">确定</Button>
                                                </div>
                                            </div>
                                        </div>
                                    } trigger="click" style={{width: "20px;"}} visible={this.state.videoVisible}
                                                                                  onVisibleChange={this.handleVideoVisibleChange}
                                                                                  arrowPointAtCenter>
                                        <img style={{cursor: "pointer", padding: "10px 10px 0px 10px"}}
                                             src={"/cm-sites/images/mediaFusion/shipin.png"}/>
                                    </Popover>
                                }

                                <Popover
                                    placement="bottom"
                                    content={
                                        <div style={{width: "325px", display: "flex"}}>
                                            <Input style={{width: "250px"}} ref={(that) => this.placeInput = that}
                                                   placeholder="请输入定位"/>
                                            <div style={{marginLeft: 10}}>
                                                <Button onClick={this.setPlace.bind(this)}
                                                        type="primary">确定</Button>
                                            </div>
                                        </div>
                                    }
                                    trigger="click"
                                    style={{width: "20px;"}}
                                    visible={this.state.placeVisible}
                                    onVisibleChange={this.handlePlaceVisibleChange}
                                    arrowPointAtCenter
                                >
                                    <img style={{cursor: "pointer", padding: "10px 10px 0px 10px"}}
                                         src={"/cm-sites/images/mediaFusion/dingwei.png"}/>
                                </Popover>
                                {this.renderCheck()}
                                <SecurityCheck ref={ref=>this.securityCheck=ref}/>
                                <style>{`#weiboPopover .ant-popover-placement-bottomLeft{padding-top: 0;}`}</style>
                            </div>
                            <div>
                            <span style={{
                                color: this.state.fontSize > 500 ? "red" : "",
                                marginLeft: 5
                            }}>{this.state.fontSize}</span>/500
                            </div>
                        </div>
                        <div style={{clear: 'both'}}/>
                        <div id={"treeBox"} style={{overflowY: 'auto', maxHeight: 455}}>
                            <div>
                                <EditableTagGroup
                                    type={'weibo'}
                                    checkData={this.checkData}
                                    syncTagsToSuperclass={this.syncTagsToSuperclass.bind(this)}
                                    ref={(that) => this.editableTagGroup = that}
                                    tags={this.state.tags}
                                />
                            </div>
                            {this.state.isTouTiaoArticle ?
                                <div style={{position: 'relative'}} title={'点我去头条文章'}>
                                    <img src={this.state.touTiaoArticleInfor.cover}
                                         style={{width: 600, height: 257, objectFit: 'cover', cursor: 'pointer'}} alt=""
                                         onClick={() => {
                                             this.clickTouTiaoImg();
                                         }}/>
                                    <div style={{
                                        width: 600,
                                        background: 'rgba(0, 0, 0, 0.45)',
                                        position: "absolute",
                                        bottom: 0,
                                        color: "rgba(255, 255, 255, 0.85)",
                                        fontSize: 14,
                                        padding: 10
                                    }}>
                                        <div title={this.state.touTiaoArticleInfor.title} style={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            wordWrap: 'break-word',
                                            overflow: 'hidden'
                                        }}>{this.state.touTiaoArticleInfor.title}</div>
                                        <div title={this.state.touTiaoArticleInfor.summary} style={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            wordWrap: 'break-word',
                                            overflow: 'hidden'
                                        }}>{this.state.touTiaoArticleInfor.summary}</div>
                                    </div>
                                </div>
                                : <div style={{width: "440px", height: this.state.isTouTiaoArticle ? "230px" : ""}}>
                                    <div style={{paddingLeft: "230px", paddingTop: "0px", position: "absolute"}}/>
                                    <WeiboPicturesWall handleRemove={this.handleRemove.bind(this)}
                                                       isShowRemoveBtn={this.statusName.indexOf("发布") <= -1}
                                                       ref={(that) => this.weiboPicturesWall = that} listShow={false}
                                                       fileList={this.state.fileList}/>
                                </div>}
                        </div>
                        <style>{
                            `
                    #treeBox::-webkit-scrollbar { 
                            width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
                            height:0px;
                        }
                    #treeBox::-webkit-scrollbar-thumb {
                            border-radius: 10px;
                            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                            background: rgba(0,0,0,0.2);
                        }
                    #treeBox::-webkit-scrollbar-track {
                            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.02);
                            border-radius: 0;
                            background: rgba(0,0,0,0.01);
                       }
                    
                    `
                        }</style>
                    </div>
                </Scrollbars>
                <Divider style={{display: (this.state.btns.length || this.state.actBtn.length) ? "block" : "none"}}/>
                <style>{`#editWeibo .ant-divider-horizontal{margin: 0;}`}</style>
                <Modal
                    title={this.textareaModalTitle}
                    visible={this.state.textareaModalVisible}
                    onOk={this.textareaHandleOk}
                    onCancel={this.textareaHandleCancel}
                >
                    <TextArea ref={that => this.remarks = that} placeholder="请输入备注" maxLength={200}/>
                </Modal>

                <ChooseUserModal ref={"chooseUserModal"} onCancel={this.closeLoad}/>
                <LinkCheck ref={(LinkCheck) => {
                    this.LinkCheck = LinkCheck
                }}/>
                <SyncModal ref={ref=>this.syncModal=ref}/>
            </div>
        )
    };
    renderRight = () => {
        let SENSITIVE = 0;
        let OUTSIDE_CHAIN = 0;
        let config = [
            {
                name: "微博正文区域",
                key: "title",
                checkList: []
            },
            {
                name: "微博标签区域",
                key: "tags",
                checkList: []
            },
            {
                name: "文章摘要区域",
                key: "summary",
                checkList: []
            },
            {
                name: "文章正文区域",
                key: "content",
                checkList: []
            },
        ];
        for(let i in this.checkData) {
            let item = this.checkData[i];
            if(item?.length) {
                for(let k=0;k<item.length;k++) {
                    let Item = item[k];
                    if(Item?.category === "OUTSIDE_CHAIN") {
                        OUTSIDE_CHAIN++
                    } else {
                        SENSITIVE++
                    }
                    let find = config.find(item=>item.key===i);
                    if(find?.checkList?.push) {
                        find.checkList.push(formatItem(Item))
                    }
                }
            }
        }
        return (
            <div style={{
                display: "flex",
                width:416,
                flexDirection: "column",
                height: 516,
                borderLeft: "1px solid #e8e8e8",
                borderBottom: "1px solid #e8e8e8",
                fontSize:12,
            }}>
                <div style={{flex:1,height: 516,padding: 24}}>
                    <Scrollbars style={{height: "100%",width:"100%"}}>
                        <div title={"统计区"} style={{padding:12,background:"#fff9f9",height:91,border: "1px solid #fee",fontSize:14,borderRadius: "5px"}}>
                            <div>当前微博</div>
                            <div>敏感信息：<span style={{color:"#dc7e77"}}>{SENSITIVE}</span> 条</div>
                            <div>疑似外链：<span style={{color:"#e6ad5d"}}>{OUTSIDE_CHAIN}</span> 条</div>
                        </div>
                        {
                            config.map(item=>{
                                if(item.checkList?.length) {
                                    return (
                                        <div key={item?.key} title={item?.name} style={{marginTop:16}}>
                                            <div style={{width: 367,height: 32,display: "flex",alignItems: "center",paddingLeft: 8,background: "#ebf1f9",fontSize:14,}}>{item?.name}</div>
                                            <div style={{dispaly:"flex"}}>
                                                {
                                                    item.checkList.map((item,index) => {
                                                        return (<div key={index} style={{padding: "12px 8px"}}>
                                                            {item}
                                                        </div>)
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                                return ""
                            })
                        }
                    </Scrollbars>
                </div>
                <div style={{
                    height:40,
                    borderTop: "1px solid #e8e8e8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Button id={"againCheck"} onClick={this.onCheckBtn}>再次检测</Button>
                    <style>
                        {
                            `
                            #againCheck {
                                color: rgba(0, 0, 0, 0.65) !important;
                            }
                            `
                        }
                    </style>
                </div>
            </div>
        )
    };
    renderBottom = () => {
        return (
            this.props.isDisabled ? null :
                    <div style={{
                        display: "flex", justifyContent: "center", alignItems: "center", padding: "10px 40px"
                    }}>
                        {/*其他按钮*/}
                        {this.state.btns.map((btn, index) => {
                            return (
                                <div className={"weiboBtn"} key={uuid()} style={{
                                    width: "auto",
                                    height: 32,
                                    cursor: "pointer",
                                    marginRight: 16,
                                    padding: "5px 10px 5px 13px",
                                    color: window.sysConfig && window.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3')||'#0050B3',
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    textAlign: "center",
                                    background: "#fff",
                                    borderRadius: "4px",
                                    letterSpacing: "2px",
                                    border: "1px solid rgba(0, 0, 0, 0.15)"
                                }} onClick={() => this.onClick(btn.type)}>
                                    {btn.name}
                                </div>
                            )
                        })}
                        {/*流程按钮*/}
                        {this.renderActBtn()}
                        <style>{`
                        .weiboBtn{
                            transition: .3s;
                            -webkit-touch-callout: none; /* iOS Safari */
                            -webkit-user-select: none; /* Chrome/Safari/Opera */
                            -khtml-user-select: none; /* Konqueror */
                            -moz-user-select: none; /* Firefox */
                            -ms-user-select: none; /* Internet Explorer/Edge */
                            user-select: none;
                        }
                        .weiboBtn:hover{
                            border-color: #096dd9 !important;
                        }
                        /*点击*/
                        .weiboBtn:active{
                            box-shadow: 0 0 0 6px #0050b326;
                            transition: .1s;
                        }
                    `}</style>
                    </div>
        )
    };
    render() {
        return (
            <Spin spinning={this.state.loading} id={"editWeibo"}>
                <div style={{display: "flex"}}>
                    {this.renderLeft()}
                    {
                        this.state.isTouTiaoArticle === true && this.count>0 ? (
                            this.renderRight()
                            ) : ""
                    }
                </div>
                {this.renderBottom()}
            </Spin>
        );
    }

    //渲染流程按钮
    renderActBtn = () => {
        let {activityOption} = this.state;
        return (
            activityOption && activityOption.activitiConf ? <ActivitiModal {...activityOption}/> : ""
        )
    };

    //头条文章图片点击
    clickTouTiaoImg() {
        let toutiaoParms = {
            ...this.state.currentData,//复制微博所有的数据，用特定需要的数据去覆盖
            initWeiBoId: this.state.weiboId,
            isAdd: false,
            content: this.getTitleText(),
            labelNames: this.state.tags,//标签名字
            touTiaoArticle: this.state.touTiaoArticleInfor,
        };
        this.props.touTiaoParmsCallback && this.props.touTiaoParmsCallback(toutiaoParms,this.state.noInfoCheckRecord||[]);
    }

    timeOnChange(value, dateString) {
        this.setState({timeSelect: value})
    }

    timeOnOk(value) {
        this.setState({timeSelect: value})
    }

    //@搜索人
    handleSearchUserName = value => {
        if (value) {
            value = value.slice(0, 50);
            this.state.userNameValue = value;
            let body = {
                mediaId: this.state.mediaId,
                keyword: value,
            };
            searchUser(body, (data) => {
                if (data.length > 0) {
                    this.setState({userNameData: data});
                }
            });
        } else {
            this.setState({userNameData: []});
        }
    };

    handleChangeUserName = value => {
        let newValue = this.contentWapper.insetIntoTextArea('@' + value);
        this.setContent(newValue);
        this.state.userNameValue = '';
        this.setState({
            userNameVisible: false,
            openUserName: false
        });
    };


    //话题
    handleSearchTopic = value => {
        if (value) {
            value = value.slice(0, 50);
            this.state.topicValue = value;
            let body = {category: this.state.topicId, query: value};
            hotTopic(body, (data) => {
                let Data = data.data;
                if (Data && Data.detail.length > 0) {
                    this.setState({topicData: Data.detail});
                }
            })
        } else {
            this.setState({topicData: []});
        }
    };

    handleChangeTopic = value => {
        let newValue = this.contentWapper.insetIntoTextArea(value);
        this.setContent(newValue);
        this.state.topicValue = '';
        this.setState({
            openTopic: false,
            htVisible: false,
        });
    };

    tabChange(key) {
        this.state.topicId = key;
        let body = {category: key, query: null};
        hotTopic(body, (data) => {
            let Data = data.data;
            if (key.length && key.length > 0) {
                if (Data && Data.more_detail.length > 0) {
                    this.setState({topicData: Data.more_detail});
                }
            } else {
                if (Data && Data.detail.length > 0) {
                    this.setState({topicData: Data.detail});
                }
            }


        })
    }

    //定位
    handleSearch = value => {
        if (value) {
            value = value.slice(0, 50);
            this.state.placeValue = value;
            let body = {q: value};
            location(body, (data) => {
                let Data = data.data;
                if (Data && Data.detail.length > 0) {
                    this.setState({placeData: Data.detail});
                }
            })
        } else {
            this.setState({placeData: []});
        }
    };

    handleChange = value => {
        let newValue = this.contentWapper.insetIntoTextArea(value);
        this.setContent(newValue);
        this.state.placeValue = '';
        this.setState({
            placeVisible: false,
            openPlace: false
        });
    };

    checkData = {};
    renderCheck = () => {
        if(typeof this.securityCheck?.renderCheckBtn === "function") {
            let icon = this.securityCheck.renderCheckBtn({btnType:"icon"});
            let {count,checkStatus} = this.securityCheck.getCheckResult(["count","checkStatus"]);
            let num = "";
            if(checkStatus === "over" && count > 0) {
                num = count > 9 ? "9+" : count
            }
            return (
                <Tooltip placement={"top"} title={(()=>{
                    switch (checkStatus) {
                        case "change" :
                            return "发现编辑器内容变化，请重新检测";
                        case "loading" :
                            return "检测中请稍后";
                        default :
                            return "单击开始内容检测"
                    }
                })()}>
                    <div
                        style={{
                            position: "relative",
                            cursor:"pointer",
                            display: "inline-block",
                            padding: "10px 10px 0px",
                            verticalAlign: "middle",
                        }}
                        onClick={()=>this.onCheckBtn()}
                    >
                        <img
                            style={{width:20}}
                            src={icon}
                        />
                        <span
                            style={{
                                paddingTop: 10,
                                position: "absolute",left:0,top:0,zIndex:998,
                                width: "100%",height: "100%",
                                textAlign: "center",lineHeight: "22px",
                                color:"#fff", fontSize:12,
                            }}
                        >{num}</span>
                    </div>
                </Tooltip>
            )
        } else {
            return ""
        }
    };

    onCheckBtn = () => {
        this.onCheck((res)=>{
            let msg = res?.msg;
            switch (res?.code) {
                case 0:
                    // 没有敏感词
                    message.success(msg || "未检测到敏感信息");
                    break;
                case 1:
                    // 检测到敏感词
                    message.warning(msg || "检测到敏感信息");
                    break;
                case -1:
                    // 检测报错
                    message.error(msg || "敏感词检测失败");
                    break;
                default:
                    // 未知错误
                    message.warning(msg || "敏感词检测失效，无法进行异步检测");
            }
            let {count,checkStatus} = this.securityCheck.getCheckResult(["count","checkStatus"]);
            this.count = count;
            this.checkData = res.data;
            this.setCheckTitle();
            this.setState({});
        })
    };

    onCheck = (call) => {
        message.destroy();
        if(!(this.weiboId || this.state.weiboId)) {
            message.warning("请先保存再检测");
            return false
        }
        if(typeof this.securityCheck.asyncCheck === "function") {
            this.getCheckData(({contents,data,key})=>{
                this.checkNoInfoCheckRecord();
                this.securityCheck.asyncCheck({contents,data,key,
                    call:(res)=>{
                        call&&call(res)
                    }
                });
            });
        } else {
            message.warning("敏感词检测失效，无法进行异步检测");
        }
    };

    checkNoInfoCheckRecord = () => {
        if(this.state.noInfoCheckRecord?.length) {
            this.state.noInfoCheckRecord.forEach(item=>{
                if(typeof this.securityCheck.asyncCheck === "function") {
                    this.getCheckData(({contents,data,key})=>{
                        this.securityCheck.asyncCheck({contents:item?.contents,data,key,
                            call:(res)=>{
                                if(item?.key) {
                                    this.state.noInfoCheckRecord = this.state.noInfoCheckRecord.filter(Item=>Item.key!==item.key)
                                }
                                if(typeof this.props.onCheckNoInfoCall === "function") {
                                    this.props.onCheckNoInfoCall(item?.key)
                                }
                            }
                        });
                    });
                }
            })
        }
    };

    getCheckData = (call) => {
        let title = this.getTitleText();
        if(!(title?.length && title.trim().length)) {
            message.warning("请输入微博正文后再进行检测");
            return false
        }
        let contents = {};
        // 获取标签
        let tagsStr = [];
        if (this.editableTagGroup) {
            let tagsList = this.editableTagGroup.state.tags;
            for (let i = 0; i < tagsList.length; i++) {
                tagsStr.push(tagsList[i]);
            }
            contents.tags = tagsStr.toString();
        }
        // 获取微博正文
        contents.title = title || "";
        // 获取头条
        if(this.state.isTouTiaoArticle && this.state.touTiaoArticleInfor) {
            contents.content = this.state.touTiaoArticleInfor.content;
            contents.summary = this.state.touTiaoArticleInfor.summary;
        }
        let data = {
            contents,
            data: {
                "id": this.weiboId || this.state.weiboId || "",
                "check_info_url": "/cm-sites-pms/weibo/getById?id="+this.weiboId,
                "storyName": title || "",
                "storyStatusName": this.state.currentItem.statusName || "",
                "mediaName": this.state.currentItem.mediaName || this.state.mediaName,
                "createUserName": window.currentUser?.name || "",
                "deptName": window.currentUser?.defaultInfo?.dept?.name || "",
                "createStoryUserName": this.state.currentItem?.submitterName || window.currentUser?.name || "",
                "createStorydeptName": window.currentUser?.defaultInfo?.dept?.name || "",
                "createStoryMediaName": this.state.currentItem.mediaName || this.state.mediaName,
            },
            key: this.weiboId || this.state.weiboId || "",
        };
        call&&call(data)
    };

    // 判定保存后是否需要检测敏感词
    checkActionDecision = (activiti,isOnlySave) => {
        let status = activiti?.options?.statusNameTemp;
        let btnName = activiti?.options?.item?.btnName;
        let needCheckStatus = this.sysConfigGetValueByKey("need.check.status.weibo","已发布");
        if (isOnlySave === "onlySave" || !activiti) {
            return (
                needCheckStatus.indexOf("暂存") > -1 ||
                needCheckStatus.indexOf("保存") > -1 ||
                needCheckStatus.indexOf("全部") > -1
            )
        }
        return (needCheckStatus && ((status && needCheckStatus.indexOf(status) > -1) || ( btnName&&needCheckStatus.indexOf(btnName) > -1) || needCheckStatus.indexOf("全部")>-1)) ? true : false
    };

    onCheckSave = (call,activiti,isOnlySave) => {
        // 判定是否需要敏感词检测
        if(this.checkActionDecision(activiti,isOnlySave)) {
            this.onCheck((res)=>{
                let msg = res?.msg;
                let {count,checkStatus} = this.securityCheck.getCheckResult(["count","checkStatus"]);
                switch (res?.code) {
                    case 0:
                        // 没有敏感词
                        call&&call();
                        break;
                    case 1:
                        window.loading.hide();
                        // 检测到敏感词
                        if(activiti?.options?.statusNameTemp) {
                            Modal.confirm({
                                title: "检测到当前微博含有敏感信息",
                                content: "建议返回修改",
                                cancelText: "全部忽略并继续",
                                okText: "返回修改",
                                icon: "exclamation-circle",
                                centered:true,
                                onOk: ()=>{
                                    this.count = count;
                                    this.checkData = res.data;
                                    this.setCheckTitle();
                                    this.setState({});
                                },
                                onCancel: ()=>{
                                    call&&call()
                                },
                            });
                            return false
                        } else {
                            Modal.warning({
                                title: "检测到当前微博含有敏感信息",
                                content: "建议返回修改",
                                okText: "返回修改",
                                icon: "exclamation-circle",
                                centered:true,
                                onOk: ()=>{},
                            });
                        }
                        break;
                    case -1:
                        window.loading.hide();
                        // 检测报错
                        message.error(msg || "敏感词检测失败");
                        break;
                    default:
                        window.loading.hide();
                        // 未知错误
                        message.warning(msg || "敏感词检测失效，无法进行异步检测");
                }
                this.count = count;
                this.checkData = res.data;
                this.setCheckTitle();
                this.setState({});
            });
        } else {
            call&&call()
        }
    };

    renderCheckResult = () => {
        let render = "";
        let SENSITIVE = 0;
        let OUTSIDE_CHAIN = 0;
        let checkList = [];
        for(let i in this.checkData) {
            let item = this.checkData[i];
            if(item?.length) {
                for(let k=0;k<item.length;k++) {
                    let Item = item[k];
                    if(Item?.category === "OUTSIDE_CHAIN") {
                        OUTSIDE_CHAIN++
                    } else {
                        SENSITIVE++
                    }
                    checkList.push(formatItem(Item))
                }
            }
        }
        if(checkList?.length) {
            render = (
                <div style={{padding: "0px 0px 8px 0px"}}>
                    <div style={{background: '#fff9f9',border: '1px solid #fee',height: 43,lineHeight: '43px',padding: '0px 12px'}}>检测到 敏感信息 <span style={{color: "red"}}>{SENSITIVE}</span> 条 疑似外链 <span
                        style={{color: "blue"}}>{OUTSIDE_CHAIN}</span> 条
                    </div>
                    <div style={{padding: "8px 8px 0px"}}>
                        <Scrollbars autoHeight autoHide autoHeightMax={120}>
                            <div style={{display: "flex",flexDirection: "column",}}>
                                {checkList}
                            </div>
                        </Scrollbars>
                    </div>
                </div>
            )
        }
        return  render
    };

    // 获取描述内容txt
    getTitleText = () => {
        const innerText = $("#TextArea")?.[0]?.textContent
        if(innerText || innerText === "") {
            return innerText;
        }
        let title = this.state.content?.length ? this.state.content : "";
        title = removeContentSecurity(title);
        title = title.replace(/<div><br><\/div>/g,"/n");
        title = title.replace(/<div>/g,"<div>/n");
        title = $(`<div>${title}</div>`).text();
        return title
    };
    // 获取描述内容html（无标记）
    getTitleHtml = () => {
        if($("#TextArea")?.html) {
            return removeContentSecurity($("#TextArea").html());
        }
        let title = this.state.content?.length ? this.state.content : "";
        title = removeContentSecurity(title);
        title = $(`<div>${title}</div>`).html();
        return title
    };
    // 获取描述长度
    getTitleLength = () => {
        let num = 0;
        let title = this.getTitleText();
        if(title.length){
            num =  title.length
        }
        return num
    };
    // 给正文打敏感词标记
    setCheckTitle = () => {
        let title = this.getTitleHtml();
        if(this.checkData?.title?.length) {
            this.checkData.title.sort((a,b)=>b.word.length-a.word.length);
            let titles =[];
            this.checkData.title.forEach(tit=>{
                if (!titles.some(item=>item.word == tit.word)) {
                    titles.push(tit);
                }
            })
           titles.forEach(item=>{
                let replaceWord = addContentSecurityByText(item?.word);
                // let reg = `([>][^<]*)${item?.word}([^>]*[<])`;
                // title = title.replace(new RegExp(reg,"g"),`$1${replaceWord}$2`);
                title = this.checkWordReplace(title,item?.word,replaceWord);
            })
        }
        this.state.content = title
    };

    checkWordReplace = (content, word,replaceHtml) => {
        let newTxt = content;
        const regex = /(^|>)[^><]+?(?=$|<)/g;
        return  newTxt.replace(regex, (match) => {
            return match.replace(new RegExp(word,"g"), replaceHtml);
        });
    };
}

EditWeiBo.defaultProps = {
    content: "",
    removeWeibo: () => {
    }
}

class WeiboContentForm extends Component {

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    initFields(props) {
        const {fieldData} = props;
        const {setFields} = props.form;
        if (fieldData && this.fieldData !== fieldData) {
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    handleContentChange(html) {
        this.props.setContent(html);
    }
    onChangeByCheck() {
        this.props.onChangeByCheck();
    }
    render() {
        const {getFieldDecorator} = this.props.form;
        let formData = this.props.form.getFieldsValue(); // 是真实数据
        let content = formData?.content || "";
        return (
            <div style={{width: "100%", height: "88px", border: '1px solid rgba(0,80,179,0.08)'}}
                 id={"weiboInput"}>
                <Form>
                    <Form.Item>
                        {getFieldDecorator('content', {
                            rules: [{required: true, message: '请输入微博正文！'}],
                        })(
                            <Scrollbars autoHeight autoHeightMax={88}>
                                <RmtTextArea
                                    ref={(that) =>{
                                        this.props.contentWapper.dom = ReactDOM.findDOMNode(that)
                                        this.rmtTextAreaRef = that
                                    }}
                                    className={"weiboContent"}
                                    onChange={(html,e)=>{
                                        console.log("onChange",html);
                                        this.props.contentWapper.update(e);
                                        const newHtml = removeColorByInheritCheck(this.rmtTextAreaRef.textAreaDivRef())(this.rmtTextAreaRef?.getContent);
                                        this.handleContentChange(newHtml || html);
                                        // this.handleContentChange(html);
                                        this.onChangeByCheck();
                                    }}
                                    style={{minHeight: 88,}}
                                    content={content}
                                />
                                {/*<div*/}
                                {/*    ref={(that) => this.props.contentWapper.dom = ReactDOM.findDOMNode(that)}*/}
                                {/*    className={"weiboContent"}*/}
                                {/*    id={"TextArea"}*/}
                                {/*    onInput={(e) => {*/}
                                {/*        // 监听到内容改变，改变敏感词检测状态*/}
                                {/*        console.log("onInput", e.target.innerText);*/}
                                {/*        // this.handleContentChange(e);*/}
                                {/*        this.onChangeByCheck();*/}
                                {/*    }}*/}
                                {/*    onBlur={(e) => {*/}
                                {/*        // 监听到拾取焦点，将文本数据存储*/}
                                {/*        console.log("onBlur", e.target.innerText);*/}
                                {/*        this.props.contentWapper.update(e);*/}
                                {/*        // let text = removeContentSecurity(e.target.innerText);*/}
                                {/*        // this.state.body.title = e.target.innerText;*/}
                                {/*        this.handleContentChange(e);*/}
                                {/*        // this.setState({}, () => {*/}
                                {/*        // })*/}
                                {/*    }}*/}
                                {/*    style={{*/}
                                {/*        minHeight: 88,*/}
                                {/*        border: 'none',*/}
                                {/*        resize: 'none',*/}
                                {/*        outline: 'none',*/}
                                {/*        padding: "4px 11px",*/}
                                {/*        lineHeight: "normal",*/}
                                {/*        whiteSpace: 'pre-line',*/}
                                {/*        backgroundColor: 'rgba(0,80,179,0.04)',*/}
                                {/*    }}*/}
                                {/*    contentEditable="true"*/}
                                {/*    type='customTextarea'*/}
                                {/*    spellCheck="false"*/}
                                {/*    dangerouslySetInnerHTML={{__html: '<div>' + newTitle + '</div>'}}*/}
                                {/*>*/}
                                {/*</div>*/}
                            </Scrollbars>
                        )}
                    </Form.Item>
                    <style>{
                        `.weiboContent::-webkit-scrollbar {
                            width: 6px;
                            height: 6px;
                        }
                        .weiboContent::-webkit-scrollbar-thumb {
                            border-radius: 3px;
                            -moz-border-radius: 3px;
                            -webkit-border-radius: 3px;
                            background-color: #c3c3c3;
                        }
                        .weiboContent::-webkit-scrollbar-track {
                            background-color: transparent;
                        }`
                    }</style>
                </Form>
            </div>
        )
    }
}

const WrappedWeiboContentForm = Form.create()(WeiboContentForm);

class TextAreaWapper {

    dom;
    insertStartIndex;
    insertEndIndex;
    scrollPosition;

    lastLeaveTextAreaStyle = {
        insert: (value) => {
            let newValue = this.dom.innerText.substring(0, this.insertStartIndex) + value + this.dom.innerText.substring(this.insertEndIndex, this.dom.innerText.length);
            this.dom.scrollTop = this.scrollPosition;
            this.insertStartIndex += value.length;
            this.insertEndIndex = this.insertStartIndex;
            this.dom.innerText = newValue;
            return newValue;
        },
        append: (value) => {
            let newValue = this?.dom?.innerText + value;
            this.dom.innerText = newValue;
            return newValue;
        }
    };
    insertTextAreaStyle = "append";

    insetIntoTextArea = (value) => {
        return this.lastLeaveTextAreaStyle[this.insertTextAreaStyle](value);
    };

    update = (e) => {
        this.dom = e.target;
        if (this.dom.selectionStart || this.dom.selectionStart == '0') {
            this.insertTextAreaStyle = "insert";
            this.insertStartIndex = this.dom.selectionStart;
            this.insertEndIndex = this.dom.selectionEnd;
            this.scrollPosition = this.dom.scrollTop;
        } else {
            this.insertTextAreaStyle = "append";
        }
        ;
    }
}
export default EditWeiBo;